var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { assertExists } from '@blocksuite/global/utils';
import { WithDisposable } from '@blocksuite/lit';
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BLOCK_ID_ATTR } from '../../../../_common/consts.js';
import { EditIcon } from '../../../../_common/icons/text.js';
import { toggleBookmarkEditModal } from '../../../../bookmark-block/components/index.js';
let EdgelessChangeBookmarkButton = class EdgelessChangeBookmarkButton extends WithDisposable(LitElement) {
    render() {
        return html `<div class="change-bookmark-container">
      <icon-button
        size="32px"
        ?disabled=${this.page.readonly}
        @click=${() => {
            const bookmark = this.surface.edgeless.querySelector(`[${BLOCK_ID_ATTR}="${this.bookmark.id}"]`);
            assertExists(bookmark);
            toggleBookmarkEditModal(bookmark);
        }}
      >
        ${EditIcon}
        <affine-tooltip .offset=${12}>Edit</affine-tooltip>
      </icon-button>
    </div>`;
    }
};
EdgelessChangeBookmarkButton.styles = css `
    .change-bookmark-container {
      display: flex;
    }
  `;
__decorate([
    property({ attribute: false })
], EdgelessChangeBookmarkButton.prototype, "bookmark", void 0);
__decorate([
    property({ attribute: false })
], EdgelessChangeBookmarkButton.prototype, "page", void 0);
__decorate([
    property({ attribute: false })
], EdgelessChangeBookmarkButton.prototype, "surface", void 0);
EdgelessChangeBookmarkButton = __decorate([
    customElement('edgeless-change-bookmark-button')
], EdgelessChangeBookmarkButton);
export { EdgelessChangeBookmarkButton };
//# sourceMappingURL=change-bookmark-button.js.map